// A whole-number field somebody types into.
//
// The obvious shape, `value={n}` with `onChange={e => setN(parseInt(e.target.value) || 1)}`,
// cannot be edited: an empty box parses as NaN, the fallback substitutes the
// minimum, and React writes it back before the next keystroke, so the last digit
// can never be deleted. Keep the raw text in state while the person is typing and
// turn it into a number once, when the form is submitted.

// What to store as the field is typed into. The empty string is a legitimate
// intermediate state and is preserved; anything that is not a digit is dropped,
// so a pasted value or a browser that delivers "e" and "-" from a number input
// cannot leave the box unparseable.
export function sanitiseQuantityInput(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}

// The number to submit. An empty box means one item, and the result is held
// inside the range the input advertises, which the spinner and a paste can both
// escape.
export function commitQuantity(raw, { min = 1, max = 200 } = {}) {
  const n = parseInt(sanitiseQuantityInput(raw), 10);
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, n));
}
